import { Snowflake, Wrench, Flame, Home, TreePine, Printer } from "lucide-react";
import BrickTitle from "@/components/landing/BrickTitle";

const services = [
  {
    icon: Snowflake,
    title: "HVAC & AC Repair",
    desc: "EPA certified diagnostic, refrigerant balance, thermostat wiring, compressor checks, and duct efficiency fixes.",
    tag: "EPA Universal Certified",
    highlight: true,
  },
  {
    icon: Wrench,
    title: "Plumbing & Water Systems",
    desc: "Fixing pipe bursts, drain clear-outs, faucet & fixture replacements, garbage disposals, and water heater servicing.",
    tag: "Fast Leak Stoppage",
  },
  {
    icon: Flame,
    title: "Welding & Metal Fabrication",
    desc: "On-site structural steel repair, custom iron gates, handrails, trailer fixes, and heavy-duty reinforced brackets.",
    tag: "MIG & Arc Welding",
  },
  {
    icon: Home,
    title: "Roofing & Gutter Control",
    desc: "Flashing seals, shingle repairs, gutter pitch realignment, leaf guard installations, and complete water runoff management.",
    tag: "Storm Drainage Secure",
  },
  {
    icon: TreePine,
    title: "Custom Wood Pieces",
    desc: "Built-in shelving, hardwood repairs, custom farmhouse tables, mantlepieces, deck restoration, and fine architectural trim.",
    tag: "Handcrafted Joinery",
  },
  {
    icon: Printer,
    title: "3D Printing & Obsolete Parts",
    desc: "Custom replacement gears, brackets, vintage appliance clips, and bespoke prototypes engineered when OEM parts are gone.",
    tag: "CAD Modeling & Print",
  },
];

export default function Services() {
  return (
    <section id="services" className="py-20 max-w-6xl mx-auto px-4 sm:px-6" data-testid="services-section">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <span className="text-xs font-bold uppercase tracking-widest text-[#D4691E]">Total Capability</span>
        <h2 className="text-3xl sm:text-4xl font-bold mt-2">
          <BrickTitle text="Every Home Component Repaired" />
        </h2>
        <p className="text-sm text-[#A89F94] mt-3">
          No need to juggle five different sub-contractors. Complete residential mechanical, structural, and bespoke
          repairs handled under one single roof.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {services.map((s) => (
          <div
            key={s.title}
            data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className="bg-white p-7 rounded-xl border border-[#E6DCD3] hover:border-[#D4691E] transition-colors shadow-sm"
          >
            <div className="w-12 h-12 rounded-lg bg-[#FFF3EA] text-[#D4691E] flex items-center justify-center mb-5">
              <s.icon className="w-6 h-6" />
            </div>
            <h3 className="font-bold text-lg text-[#1E252B] mb-2">{s.title}</h3>
            <p className="text-sm text-[#665E56] leading-relaxed mb-4">{s.desc}</p>
            <span
              className={`text-xs font-semibold px-2.5 py-1 rounded ${
                s.highlight ? "text-[#D4691E] bg-[#FFF3EA]" : "text-[#544D45] bg-[#F5EFEB]"
              }`}
            >
              {s.tag}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
